import {createReducer} from '../utils';
import {SHOW_SERIALHELP_OVERLAY,DISMISS_SERIALHELP_OVERLAY} from '../constants';

const initialState = {
    isActive: false
};

export default createReducer(initialState, {
    [SHOW_SERIALHELP_OVERLAY]: (state, payload) => {
       return Object.assign({}, state, {
            isActive: true
        });
    },
    [DISMISS_SERIALHELP_OVERLAY]: (state, payload) => {
       return Object.assign({}, state, {
            isActive: false
        });
    }
});



// WEBPACK FOOTER //
// ./src/reducers/serialhelpoverlay.js